<template>
  <v-container fluid class="tp-page">
    <!-- Cabeçalho -->
    <div class="tp-page-head">
      <div>
        <h1 class="tp-page-title">Igrejas</h1>
        <p class="tp-page-sub">
          {{ tabela.conteudo.length }} no total
          <template v-if="qtdComPlano"> · {{ qtdComPlano }} com assinatura · <strong style="color:#00695C">{{ totalMensalidadesFmt }}/mês</strong></template>
        </p>
      </div>
      <div class="tp-head-actions">
        <v-text-field v-model="tabela.busca" prepend-inner-icon="mdi-magnify" placeholder="Buscar…" hide-details dense outlined color="#00695C" class="tp-search"></v-text-field>
        <v-btn color="#00695C" dark depressed rounded class="tp-btn-add" @click="dialogoIgrejas = true">
          <v-icon left>mdi-plus-circle-outline</v-icon>Cadastrar
        </v-btn>
      </div>
    </div>

    <!-- Tabela -->
    <v-card class="tp-card" elevation="0">
      <v-data-table
        :search="tabela.busca"
        :headers="tabela.cabecalho"
        :items="tabela.conteudo"
        sort-by="titulo"
        :footer-props="{
          'items-per-page-text': 'Linhas por página',
          'items-per-page-all-text': 'Tudo',
        }"
      >
        <template v-slot:[`item.pagStatus`]="{ item }">
          <v-chip small dark :color="item.pagPago ? 'success' : '#90A4AE'">
            {{ item.pagPago ? 'Pagamento efetuado' : 'Não efetuado' }}
          </v-chip>
          <div v-if="item.pagData" style="font-size:.72rem;color:#97a3a0;margin-top:2px">{{ formatData(item.pagData) }}</div>
        </template>
        <template v-slot:[`item.gerenteEmail`]="{ item }">
          <span v-if="item.gerenteEmail">{{ item.gerenteEmail }}</span>
          <span v-else style="color:#97a3a0">—</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom v-if="item.gerenteId">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon small @click="acessarComo(item)" color="#00695C">mdi-login-variant</v-icon>
              </v-btn>
            </template>
            <span>Acessar como este gerente</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon small @click="editItem(item)" color="#00695C">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon small @click="deleteItem(item)" color="error">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.faixaMembros`]="{ item }">
          <span v-if="item.faixaMembros">{{ item.faixaMembros }}</span>
          <span v-else style="color:#97a3a0">—</span>
        </template>
        <template v-slot:[`item.valorMensalidade`]="{ item }">
          <span v-if="item.valorMensalidade" style="font-weight:600;color:#00695C">{{ formatarValor(item.valorMensalidade) }}</span>
          <span v-else style="color:#97a3a0">—</span>
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <v-icon :color="item.ativo ? 'success' : 'error'">mdi-circle</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="#94AAB4" @click="carregaIgrejas">Recarregar</v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogoIgrejas" persistent max-width="1000px" scrollable>
      <v-card class="tp-card" elevation="0">
        <v-card-title>
          <span class="tp-serif" style="font-size:1.25rem;color:#00253E;font-weight:600">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text style="padding-bottom: 0px; padding-top: 10px">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="9" lg="9">
              <v-text-field
                label="Nome*"
                outlined
                dense
                hide-details
                v-model="editedItem.nome"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3" lg="3">
              <v-text-field
                label="CNPJ*"
                v-mask="'##.###.###/####-##'"
                outlined
                dense
                hide-details
                v-model="editedItem.cnpj"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4" lg="4">
              <v-text-field
                label="Endereço*"
                outlined
                dense
                hide-details
                v-model="editedItem.endereco"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4" lg="4">
              <v-select
                label="Plano"
                :items="planos"
                item-text="faixa"
                item-value="id"
                outlined
                dense
                hide-details
                clearable
                v-model="editedItem.planoId"
                @change="aplicarPlano"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4" lg="4">
              <v-text-field
                label="Mensalidade (R$)"
                prefix="R$"
                outlined
                dense
                hide-details
                type="tel"
                v-model="editedItem.valorMensalidade"
              ></v-text-field>
            </v-col>
           <v-col cols="12" xs="12" sm="12" md="12" lg="12">
             <v-switch
              v-model="editedItem.ativo"
              label="Ativo"
              hide-details
              inset
            ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="#00695C" text large @click="dialogoIgrejas = false">Cancelar</v-btn>
          <v-btn color="#00695C" dark depressed rounded large class="tp-btn-add px-6" @click="salvarigrejas">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl, userKey } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import { PLANOS, planoPorId } from '@/plans'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      planos: PLANOS,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'CNPJ', value: 'cnpj' },
          { text: 'Endereço', value: 'endereco' },
          { text: 'Plano', value: 'faixaMembros' },
          { text: 'Mensalidade', value: 'valorMensalidade' },
          { text: 'Pagamento', value: 'pagStatus', sortable: false },
          { text: 'Gerente (e-mail)', value: 'gerenteEmail' },
          { text: 'Ativo', value: 'ativo' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        conteudo: [],
      },
      dialogoIgrejas: false,
      editedIndex: -1,
      editedItem: {
        nome: '',
        cnpj: '',
        endereco: '',
        planoId: '',
        faixaMembros: '',
        valorMensalidade: '',
        ativo: true,
      },
      defaultItem: {
        nome: '',
        cnpj: '',
        endereco: '',
        planoId: '',
        faixaMembros: '',
        valorMensalidade: '',
        ativo: true,
      },
    }),

    computed: {
      ...mapState({
        usuarioLogado: state => state.isMenuVisible,
        user: state => state.userObj,
        companyobj: state => state.companyObj,
      }),
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar nova Igreja' : 'Editar Igreja'
      },
      qtdComPlano () {
        return this.tabela.conteudo.filter(i => {
          const n = Number(String(i.valorMensalidade || '').replace(',', '.'))
          return isFinite(n) && n > 0
        }).length
      },
      totalMensalidadesFmt () {
        const total = this.tabela.conteudo.reduce((soma, i) => {
          const n = Number(String(i.valorMensalidade || '').replace(',', '.'))
          return soma + (isFinite(n) ? n : 0)
        }, 0)
        return 'R$ ' + total.toFixed(2).replace('.', ',')
      },
    },

    watch: {
      dialogoIgrejas(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      }
    },

    mounted() {
      this.carregaIgrejas()
    },

    methods: {
      formatarValor (v) {
        const n = Number(String(v).replace(',', '.'))
        if (!isFinite(n) || n <= 0) return '—'
        return 'R$ ' + n.toFixed(2).replace('.', ',')
      },
      formatData (d) {
        if (!d) return ''
        const s = String(d).substr(0, 10).split('-')
        return s.length === 3 ? `${s[2]}/${s[1]}/${s[0]}` : ''
      },
      async carregaIgrejas () {
        this.isLoading = true
        await axios.get(baseApiUrl + 'Igrejas?filter={"order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.tabela.conteudo = response.data
          }
        })
        await this.carregaGerentes()
        await this.carregaPagamentos()
        this.isLoading = false
      },

      // Mapeia o status da cobrança mais recente de cada igreja na tabela.
      async carregaPagamentos () {
        try {
          const filtro = { order: 'created DESC', fields: { igrejaId: true, tipo: true, statusPagamento: true, dataHoraPagamento: true, created: true } }
          const resp = await axios.get(baseApiUrl + 'Pagamentos?filter=' + encodeURIComponent(JSON.stringify(filtro)) + '&access_token=' + sessionStorage.getItem('accToken'))
          const porIgreja = {}
          ;(resp.data || []).forEach(p => {
            if (!p.igrejaId) return
            if (!porIgreja[p.igrejaId]) porIgreja[p.igrejaId] = { assinatura: false, cobranca: null }
            const e = porIgreja[p.igrejaId]
            if (p.tipo === 'ASSINATURA') e.assinatura = true
            else if (!e.cobranca) e.cobranca = p // 1ª (ordenado por created DESC) = mais recente
          })
          this.tabela.conteudo = this.tabela.conteudo.map(ig => {
            const e = porIgreja[ig.id]
            const cob = e && e.cobranca
            const pago = !!(cob && cob.statusPagamento === 'PAGO')
            return Object.assign({}, ig, {
              pagPago: pago,
              pagData: pago ? (cob.dataHoraPagamento || cob.created || '') : '',
            })
          })
        } catch (e) { /* silencioso */ }
      },

      // Busca o gerente (GERENTE) de cada igreja e mapeia o e-mail na tabela.
      async carregaGerentes () {
        try {
          const filtro = { where: { tipo: 'GERENTE' }, fields: { id: true, nome: true, email: true, igrejaId: true } }
          const resp = await axios.get(baseApiUrl + 'Usuarios?filter=' + encodeURIComponent(JSON.stringify(filtro)) + '&access_token=' + sessionStorage.getItem('accToken'))
          const porIgreja = {}
          ;(resp.data || []).forEach(u => { if (u.igrejaId) porIgreja[u.igrejaId] = u })
          this.tabela.conteudo = this.tabela.conteudo.map(ig => {
            const g = porIgreja[ig.id]
            return Object.assign({}, ig, {
              gerenteEmail: g ? g.email : '',
              gerenteId: g ? g.id : '',
            })
          })
        } catch (e) { /* silencioso */ }
      },

      aplicarPlano (id) {
        const p = planoPorId(id)
        if (!p) {
          // Plano limpo: zera a faixa (mantém o valor para edição manual, se houver).
          this.editedItem.faixaMembros = ''
          return
        }
        this.editedItem.faixaMembros = p.faixa
        this.editedItem.valorMensalidade = p.valor !== null ? p.valor.toFixed(2) : ''
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoIgrejas = true
        this.isLoading = false
      },

      async salvarigrejas() {
        var vm = this;

        if (this.editedItem.nome || this.editedItem.cnpj || this.editedItem.endereco) {
          this.isLoading = true

          await axios.post(baseApiUrl + 'Igrejas/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoIgrejas = false
              if (this.editedIndex == -1)
                this.criaColecao(response.data.id)
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
              this.carregaIgrejas()
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao realizar operação", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("F9A825", "Preencha os campos para prosseguir", "ATENÇÃO")
        }
      },

      async acessarComo(item) {
        const vm = this
        if (!item.gerenteId) return
        const ok = confirm('Acessar o painel como o gerente de "' + item.nome + '"?\n\nVocê sairá da conta de administrador (é só sair e entrar de novo para voltar).')
        if (!ok) return
        this.isLoading = true
        try {
          const resp = await axios.post(baseApiUrl + 'Usuarios/acessarComoIgreja?access_token=' + sessionStorage.getItem('accToken'), { igrejaId: item.id })
          const token = resp.data.token
          const userId = resp.data.userId
          const u = await axios.get(baseApiUrl + 'Usuarios/' + userId + '?access_token=' + token)
          const usuario = u.data
          sessionStorage.setItem('accToken', token)
          sessionStorage.setItem(userKey, JSON.stringify(usuario.tipo))
          sessionStorage.setItem('userPermission', usuario.tipo)
          sessionStorage.setItem('userName', usuario.nome)
          sessionStorage.setItem('user', JSON.stringify(usuario))
          sessionStorage.setItem('company', JSON.stringify({}))
          this.$store.dispatch('Logar', token)
          this.$store.dispatch('SetUser')
          this.$store.dispatch('Permission')
          this.$store.dispatch('SetUserName')
          this.$store.dispatch('SetCompany')
          this.$router.push({ path: '/home' })
        } catch (e) {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack('#EF5350', 'Não foi possível acessar como este gerente. Verifique se a igreja tem um gerente cadastrado.', 'ERRO')
        }
      },

      async deleteItem(item) {
        let vm = this
        let r = confirm('Realmente deseja EXCLUIR o cliente ' + item.nome + '?')

        if (r == true) {
          await axios.delete(baseApiUrl + 'Igrejas/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
            this.carregaIgrejas()
          })
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>